<template>
  <div class="min-h-screen" :class="isDark ? 'bg-gray-900' : 'bg-gray-50'">
    <div class="max-w-6xl mx-auto px-6 py-12">
      <div class="text-center mb-12">
        <h1 class="text-3xl font-bold" :class="isDark ? 'text-white' : 'text-gray-800'">关于</h1>
        <div class="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
      </div>

      <div class="grid md:grid-cols-2 gap-12 items-center mb-16">
        <div>
          <h3 class="text-2xl font-semibold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">Full Stack Developer</h3>
          <p class="leading-relaxed mb-6" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            热爱编程，专注于 Web 开发领域。拥有多年开发经验，熟悉 Vue.js、React、Node.js 等主流技术栈。
          </p>
          <p class="leading-relaxed mb-6" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            热衷于技术分享，喜欢将复杂的技术概念以通俗易懂的方式传达给更多人。
          </p>
          <div class="flex flex-wrap gap-3">
            <span v-for="skill in skills" :key="skill" class="px-3 py-1 text-sm rounded-full"
                  :class="isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600'">
              {{ skill }}
            </span>
          </div>
        </div>
        <div class="rounded-xl p-6 border" :class="isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'">
          <h3 class="text-lg font-semibold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">联系方式</h3>
          <div class="space-y-4">
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-green-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              <span :class="isDark ? 'text-gray-300' : 'text-gray-700'">684329</span>
            </div>
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-green-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span :class="isDark ? 'text-gray-300' : 'text-gray-700'">panzhijie@qq.com</span>
            </div>
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-green-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span :class="isDark ? 'text-gray-300' : 'text-gray-700'">温州市鹿城区</span>
            </div>
          </div>
          <div class="flex space-x-4 mt-6">
            <a href="#" class="w-10 h-10 rounded-lg flex items-center justify-center transition-colors"
               :class="isDark ? 'bg-gray-700 hover:bg-green-600' : 'bg-gray-200 hover:bg-green-500'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" :class="isDark ? 'text-gray-300' : 'text-gray-600'" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.7-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0110 4.844c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.579.688.482C17.138 18.199 20 14.426 20 10.017 20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="#" class="w-10 h-10 rounded-lg flex items-center justify-center transition-colors"
               :class="isDark ? 'bg-gray-700 hover:bg-green-600' : 'bg-gray-200 hover:bg-green-500'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" :class="isDark ? 'text-gray-300' : 'text-gray-600'" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="#" class="w-10 h-10 rounded-lg flex items-center justify-center transition-colors"
               :class="isDark ? 'bg-gray-700 hover:bg-green-600' : 'bg-gray-200 hover:bg-green-500'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" :class="isDark ? 'text-gray-300' : 'text-gray-600'" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div class="rounded-xl p-6 border mb-16" :class="isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'">
        <h3 class="text-xl font-semibold mb-6" :class="isDark ? 'text-white' : 'text-gray-800'">网站介绍</h3>
        <div class="space-y-4">
          <p class="leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            panzhijie.cn 是一个个人技术博客网站，致力于分享 Web 开发技术、编程经验和技术见解。
          </p>
          <p class="leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            在这里，你可以找到关于 Vue.js、React、Node.js、Python 等技术栈的原创文章，以及一些实用的开发工具。
          </p>
          <p class="leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            网站采用简洁、大方的设计风格，支持亮/暗主题切换，为用户提供舒适的阅读体验。
          </p>
        </div>
      </div>

      <div class="rounded-xl p-6 border" :class="isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'">
        <h3 class="text-xl font-semibold mb-6" :class="isDark ? 'text-white' : 'text-gray-800'">隐私政策</h3>
        <div class="space-y-4">
          <h4 class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-700'">1. 信息收集</h4>
          <p class="text-sm leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            我们尊重您的隐私。本网站不会收集您的个人信息，除非您主动通过注册功能提供。
          </p>
          <h4 class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-700'">2. Cookie 使用</h4>
          <p class="text-sm leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            本网站使用 Cookie 来保存用户主题偏好和登录状态。您可以随时清除浏览器 Cookie。
          </p>
          <h4 class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-700'">3. 信息安全</h4>
          <p class="text-sm leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            我们采取合理的安全措施保护您的信息，但互联网传输并非绝对安全。
          </p>
          <h4 class="font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-700'">4. 政策变更</h4>
          <p class="text-sm leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            本隐私政策可能会不定期更新，请定期查看。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'About',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      skills: ['Vue.js', 'React', 'Node.js', 'Python', 'TypeScript', 'Docker']
    }
  }
}
</script>
